//PHONE NUMBERS
export const WHATS_APP_COMERCIAL_LINK =
  "https://api.whatsapp.com/send/?phone=555192166980&text=Gostaria+de+saber+mais+sobre+a+Vida+Premiada+Krause.%0A%0ABV-5S8Y9-SX5CRGXA&type=phone_number&app_absent=0";
export const WHATS_APP_COMERCIAL_TEXT = "51 9216 6980";
